import React from "react";
import {
  TextField,
  Button,
  CircularProgress,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio, InputLabel, Select, MenuItem, FormControl,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSuccess } from "../../../Redux/AlertReducer";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export const FormEditSLider = ({
                                 data,
                                 setData,
                                 categories,
                                 isCategoriesLoading,
                               }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoadingSubmit, setIsLoadingSubmit] = React.useState(false);
  const [imageFile, setImageFile] = React.useState(null);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChange = (key, value) => {
    setData((prev) => ({ ...prev, [key]: value }));
  };
  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleRadioChange = (e) => {
    const { value } = e.target;
    setData((prev) => ({
      ...prev,
      active: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    // Append all text fields
    formDataToSend.append("title", data.title || "");
    formDataToSend.append("description", data.description || "");
    formDataToSend.append("button", data.button || "");
    formDataToSend.append("link", data.link || "");
    formDataToSend.append("active", data.active || "1");
    formDataToSend.append("page", data.page || "home");

    // Append image only if a new file was selected
    if (imageFile instanceof File) {
      formDataToSend.append("image", imageFile);
    }



    try {
      const { response } = await Helper.Post({
        url: api_Routes.Slider.Edit + id,
        hasToken :true,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response && response.success) {
        dispatch(setSuccess(true));
        navigate("/Sliders");
      }
    } catch (error) {
      console.error("Update error:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
          <TextField
              fullWidth
              margin="normal"
              label="Title"
              name="title"
              required
              value={data.title || ""}
              onChange={handleInputChange}
              variant="outlined"
          />

          <TextField
              fullWidth
              margin="normal"
              label="Description"
              name="description"
              required
              value={data.description || ""}
              onChange={handleInputChange}
              variant="outlined"
          />

          <TextField
              fullWidth
              margin="normal"
              label="Button Text"
              name="button"
              required
              value={data.button || ""}
              onChange={handleInputChange}
              variant="outlined"
          />

          <TextField
              fullWidth
              margin="normal"
              label="Link"
              name="link"
              required
              value={data.link || ""}
              onChange={handleInputChange}
              variant="outlined"
          />

          <FormControl fullWidth size="small">
            <InputLabel>Page</InputLabel>
            <Select
                value={data.page}
                label="page"
                onChange={(e) => handleChange("page", e.target.value)}
            >
              <MenuItem value="home">Home</MenuItem>
              <MenuItem value="OurServices">Our Service</MenuItem>
              <MenuItem value="WhatsappGroups">Whatsapp Groups</MenuItem>
              <MenuItem value="TelegramGroups">Telegram Groups</MenuItem>
              <MenuItem value="SkypeGroups">Teams Groups</MenuItem>
              <MenuItem value="Panels">Panels Groups</MenuItem>
              <MenuItem value="ads">Free Ads</MenuItem>
              <MenuItem value="AddPanel">Add Panel</MenuItem>
              <MenuItem value="Team">Our Team</MenuItem>
              <MenuItem value="AddGroup">Add Group</MenuItem>
              <MenuItem value="post-ad">Post Ad</MenuItem>
              <MenuItem value="smmDomains">Smm Domain</MenuItem>
              <MenuItem value="LastMinute">Last Minute</MenuItem>
            </Select>
          </FormControl>

          <div className="col-span-full">
            <TextField
                fullWidth
                margin="normal"
                label="Slider Image"
                name="image"
                type="file"
                InputLabelProps={{ shrink: true }}
                onChange={handleFileChange}
                variant="outlined"
                inputProps={{ accept: "image/*" }}
            />

            {data.image && !imageFile && (
                <div className="mt-2">
                  <p className="text-sm text-gray-600">Current Image:</p>
                  <img
                      src={data.image}
                      alt="Current slider"
                      className="mt-1 h-32 object-contain"
                  />
                </div>
            )}


          </div>



          <div className="flex items-center justify-start gap-x-3">
            <FormLabel sx={{ fontWeight: "bold" }} component="legend">
              Active:
            </FormLabel>
            <RadioGroup
                name="active"
                value={data.active || "1"}
                onChange={handleRadioChange}
                row
            >
              <FormControlLabel value="1" control={<Radio />} label="Yes" />
              <FormControlLabel value="0" control={<Radio />} label="No" />
            </RadioGroup>
          </div>
        </div>

        <Button
            type="submit"
            variant="contained"
            disabled={isLoadingSubmit}
            color="primary"
            sx={{
              display: "flex",
              marginTop: 2,
              width: "20%",
              marginX: "auto",
              fontWeight: "bold",
              justifyContent: "center",
            }}
        >
          {isLoadingSubmit ? (
              <CircularProgress size={24} color="inherit" />
          ) : (
              "Update Slider"
          )}
        </Button>
      </form>
  );
};